// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"8d3e17f8","554":"bcdc2346","684":"9fffe03c","783":"e74ae791","963":"918f0235"}[chunkId] + ".chunk.js";
};